import * as apiServices from "../services/apiServices";
import request from "../services/requestService";

export const getNodalUserDetailsAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getNodalUserDetails(params))
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
};

export const updateDownloadNodalCommentAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.updateDownloadNodalComment(params))
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    });
};
